import { render, staticRenderFns } from "./overall-service-cn-bank-translate.vue?vue&type=template&id=3b70415f&"
import script from "./overall-service-cn-bank-translate.vue?vue&type=script&lang=js&"
export * from "./overall-service-cn-bank-translate.vue?vue&type=script&lang=js&"
import style0 from "./overall-service-cn-bank-translate.vue?vue&type=style&index=0&lang=css&"
import style1 from "./overall-service-cn-bank-translate.vue?vue&type=style&index=1&lang=css&"
import style2 from "./overall-service-cn-bank-translate.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports